import { useMutation, useQueryClient } from "react-query";
import { useToast } from "@chakra-ui/react";
import { t } from "i18next";
import { postUpdateCompanyJobTypes } from "./postUpdateCompanyJobTypes";
import { TUpdateCompanyJobTypesBody } from "./types";
import { translations } from "../../../i18n/translations";
import { Queries } from "../../../constants/queries";
import { useCompany } from "../Company";

export const useUpdateCompanyJobTypes = () => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const { data: companyData } = useCompany();
  return useMutation<unknown, unknown, TUpdateCompanyJobTypesBody>(
    (payload) => postUpdateCompanyJobTypes(payload, companyData!.companyId),
    {
      onError: () => {
        toast({
          title: "Error",
          description: t<string>(translations.errors.update_company_error),
          status: "error",
          position: "top-right",
        });
      },
      onSuccess: () => {
        queryClient.invalidateQueries(Queries.Company(companyData!.companyId));
      },
    }
  );
};
